import { showError, showResponseError, hideFlash } from 'utils/messages';
import { setLocation } from 'utils/wrappers';

import Base from 'app/views/base';
import tmpl from 'templates/request_report';

export const MAX_REPORT_TIME_SPAN_DAYS = 31;

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click #request-report': 'requestReport',
  },

  initialize({ ReportClass, apiModeSelection, dateRange, dropdownSelections = [], maxDays = MAX_REPORT_TIME_SPAN_DAYS }) {
    this.ReportClass = ReportClass;
    this.apiModeSelection = apiModeSelection;
    this.dateRange = dateRange;
    this.dropdownSelections = dropdownSelections;
    this.listenTo(this.collection, 'sync', hideFlash);
    this.maxDays = maxDays;
  },

  requestReport() {
    if (this.maxDays && this.dateRange.daysBetweenDates() > this.maxDays) {
      showError(`Sorry, CSV reports are limited to ${this.maxDays} days at a time.`);
      return;
    }
    if (this.collection && !this.collection.length) {
      showError('Sorry, your requested search included no reports to generate a CSV with.');
      return;
    }

    new this.ReportClass().save(this.paramsForReport(), {
      success(model) {
        const reportId = model.get('id');
        const mode = model.get('mode');
        setLocation(`/account/reports/${model.reportType}#/${reportId}?mode=${mode}`);
      },
      error(model, resp) {
        showResponseError(resp);
      },
    });
  },

  paramsForReport() {
    return {
      send_email: true,
      ...this.apiModeSelection.getParams(),
      start_date: this.dateRange.getStartDatetimeForParam().format('YYYY-MM-DD'),
      end_date: this.dateRange.getDayAfterEndDatetimeForParam().format('YYYY-MM-DD'),
      ...this.dropdownSelections.reduce((obj, dropdownSelection) => ({
        ...obj,
        ...dropdownSelection.getParams(),
      }), {})
    };
  },

  context() {
    return {
      maxDays: this.maxDays,
    }
  },
});



// WEBPACK FOOTER //
// ./app/views/request_report_view.js